import React from "react";
import {useTranslation} from "react-i18next";
import {getShortNameFromId} from "utils/reservationUtils";
import {useTypedSelector} from "helpers/reducers";
import {BookingFilter} from "types/app";
import {Timeslot} from "types/entities/Timeslot";
import BookingDateHeaderNamed from "pages/Front/Booking/components/BookingPackageNew/components/BookingDateHeaderNamed";

const BookingSelectedFilterHeader = (props: {filter: BookingFilter; selectedTimeslot: Timeslot | null}) => {
    const {t} = useTranslation();
    const sessionLangauge = useTypedSelector(state => state.sessionState.language);

    const {filter, selectedTimeslot} = props;
    const selectedPackageName = filter.category ? getShortNameFromId(filter.category) : undefined;

    return (
        <>
            <div className="BookingSelectedFilterHeader flex items-center gap-2 xl:gap-3 order-1">
                <h2 className={"font-bold text-xl xl:text-2xl"}>{selectedPackageName}</h2>
            </div>

            <div className={"w-px h-8 bg-[#D9D9D9] hidden lg:block order-2"} />

            <div className="flex flex-col md:flex-row items-start xs:items-end md:items-center gap-0 md:gap-3 order-3 sm:justify-self-end lg:justify-self-auto">
                <span className={"font-semibold text-lg md:text-xl shrink-0"}>
                    {filter.children + filter.adults} {t("persons")}
                </span>
                {filter?.children != 0 && (
                    <span className={"text-sm md:text-sm xl:text-base leading-tight"}>
                        ({filter.adults} {t("Adults")}, {filter.children} {t("Children")})
                    </span>
                )}
            </div>

            <div className={"w-px h-8 bg-[#D9D9D9] hidden lg:block order-4"} />

            <div className={"flex items-center gap-2 order-5"}>
                <BookingDateHeaderNamed date={filter.date} />
            </div>
        </>
    );
};

export default BookingSelectedFilterHeader;
